import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarTeam } from '@factorialco/f0-react'
import { ProjectionKind, useExpensablesByTeam } from 'generated/resources/datatable.graphql'
import { ExpensesExpensableFiltersInput } from 'generated/resources/graphql'

import DataTable from 'modules/core/components/DataTable'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

import Money from '../Money'

interface ExpensablesByTeamDatatableProps {
  filters: ExpensesExpensableFiltersInput
}

const ExpensablesByTeamDatatable = ({ filters }: ExpensablesByTeamDatatableProps) => {
  const { company } = useCurrentSession()
  const { dateFilters } = usePageDateFilters()
  const { currency } = filters

  const source = useExpensablesByTeam(
    [
      {
        identifier: 'team.name',
        title: i18n.t('expenses_v2.reports.expenses_by_team.columns.team'),
        kind: ProjectionKind.Custom,
        template: '{{ team.name }}',
        render: ({ team }) => {
          return (
            <Box flexDirection="row" alignItems="center" gap="s8">
              <F0AvatarTeam name={team.name} size="md" />
              <Text.Normal size="200" weight="medium" ellipsis>
                {team.name}
              </Text.Normal>
            </Box>
          )
        },
      },
      {
        identifier: 'totalAmount',
        title: i18n.t('expenses_v2.reports.expenses_by_team.columns.total_amount'),
        kind: ProjectionKind.Custom,
        template: '{{ totalAmount }}',
        render: ({ totalAmount }) => {
          return <Money amount={totalAmount} currency={currency} />
        },
        sortBy: 'totalAmount',
      },
    ],
    {
      variables: {
        companyId: company.id,
        from: dateFilters.startDate.toISOString(),
        to: dateFilters.endDate.toISOString(),
        filters: { ...filters },
      },
    }
  )
  return (
    <Box height="s400" maxHeight="s400" overflowY="auto">
      <DataTable
        source={source}
        pagination={{ kind: 'offset', itemsPerPage: 50, infiniteScroll: true }}
        disableEditColumns
        disableExport
        sort={{ path: 'totalAmount', direction: 'desc' }}
      />
    </Box>
  )
}

export default ExpensablesByTeamDatatable
